<template>
    <div style="width: 100%;height: 100vh;border: none;overflow: hidden;">
      <iframe allowfullscreen="true" id="iframe" ref="iframeWin" :src="webSrc" style="width: 100%;height: 100%;border: none;"></iframe>
    </div>
  </template>
  <script>
  import apiUrl from '../../js/apiUrl.js'
  export default {
    data() {
      return {
        webSrc: ''
      }
    },
    created() {
        const { bookid, chapterid, detailUrl } = this.$route.query
        const userInfo = JSON.parse(sessionStorage.getItem("userLogInInfo"));
        const token = userInfo && userInfo.token ? userInfo.token : ''
        this.webSrc = `${apiUrl.zvingDomain}front/member/readResource/epub/${bookid}?token=${token}&detailUrl=${detailUrl}&chapterID=${chapterid}`
        // this.webSrc = `http://10.3.43.47:6173/index.html?id=5018&type=epub&token=${this.token}`
    }
  }
  </script> 